import React from "react";
import { Box, Stack, Button, Typography } from "@mui/joy";
import SuperApplyIcon from "../../assets/svgs/superapply.svg";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

interface SuperApplyCardProps {
  onSuperApply: () => void;
}

const SuperApplyCard: React.FC<SuperApplyCardProps> = ({ onSuperApply }) => {
  const status = useSelector((state: RootState) => state.introVideo.status);
  return (
    <Box className="bg-white rounded-[16px] shadow-sm p-5 lg:p-6 mb-4">
      <Stack
        direction="row"
        gap={1}
        alignItems="flex-start"
        className="mb-3"
      >
        <img src={SuperApplyIcon} alt="Super Apply" />
        <Box>
          <Typography level="modalHeading" sx={{ mb: 1, fontSize: "1rem" }}>
            Super Apply
          </Typography>
          <Typography
            level="description"
            sx={{
              fontSize: { xs: "0.875rem", lg: "1rem" },
            }}
          >
            We'll send your video directly to 20 businesses and provide
            feedback on it.
          </Typography>
        </Box>
      </Stack>

      <Button
        variant="solid"
        onClick={onSuperApply}
        className="w-full"
        loading={status === "loading"}
      >
        Super Apply for $10
      </Button>
    </Box>
  );
};

export default SuperApplyCard;